(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2163,54223,59679],{

/***/ 59654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18422);






var Typography = function(props) {
    var _ref = (0,_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .useTypography */ .tj)(props), Tag = _ref.Tag, classes = _ref.classes, children = _ref.children, onClick = _ref.onClick, tabIndex = _ref.tabIndex, role = _ref.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "Tag",
        "classes",
        "children",
        "onClick",
        "tabIndex",
        "role"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest), {
        children: children
    }));
};
Typography.defaultProps = {
    variant: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
    size: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16
};
Typography.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    isBold: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    mobileSize: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    tabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    role: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Typography);


/***/ }),

/***/ 18422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tj": function() { return /* binding */ useTypography; },
/* harmony export */   "w1": function() { return /* binding */ TYPOGRAPHY_TAGS; },
/* harmony export */   "y3": function() { return /* binding */ TYPOGRAPHY_SIZE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2664);
/* harmony import */ var redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19341);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34461);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var TYPOGRAPHY_TAGS = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span"
};
var TYPOGRAPHY_SIZE = {
    caption12: "caption",
    paragrapgh14: "paragrapgh-s",
    paragrapgh16: "paragrapgh-m",
    headline20: "headline-xs",
    headline24: "headline-s",
    headline38: "headline-m",
    headline46: "headline-l",
    headline56: "headline-xl"
};
var useTypography = function(_param) {
    var variant = _param.variant, isBold = _param.isBold, className = _param.className, children = _param.children, size = _param.size, mobileSize = _param.mobileSize, onClick = _param.onClick, tabIndex = _param.tabIndex, role = _param.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "variant",
        "isBold",
        "className",
        "children",
        "size",
        "mobileSize",
        "onClick",
        "tabIndex",
        "role"
    ]);
    var isDesktopResolution = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__.useSelector)(redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__/* .selectIsDesktop */ .Y6);
    var Tag = TYPOGRAPHY_TAGS[variant] || variant;
    var actualSize = isDesktopResolution || !mobileSize ? size : mobileSize;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().typography), className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[actualSize], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().boldText), isBold));
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        Tag: Tag,
        children: children,
        classes: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest);
};


/***/ }),

/***/ 79143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_Team; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx + 1 modules
var SectionTitle = __webpack_require__(36837);
// EXTERNAL MODULE: ./UI/components/Svg/index.jsx
var Svg = __webpack_require__(6778);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/SwitchTransition.js
var SwitchTransition = __webpack_require__(45989);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 3 modules
var CSSTransition = __webpack_require__(76743);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/TeamCard/styles.module.scss
var styles_module = __webpack_require__(58754);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/TeamCard/index.jsx





var Media = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 34190));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34190)
            ];
        }
    }
});
var TeamCard = function(props) {
    var handlePrevClick = props.handlePrevClick, handleNextClick = props.handleNextClick, image = props.image, name = props.name, position = props.position, description = props.description, skills = props.skills;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).card,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default())["card-header"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: handlePrevClick,
                        className: (styles_module_default())["action-button"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                            type: "arrowLeft"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: handleNextClick,
                        className: (styles_module_default())["action-button"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                            type: "arrowRight"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchTransition/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
                    timeout: 300,
                    classNames: {
                        enter: (styles_module_default())["fade-enter"],
                        enterActive: (styles_module_default())["fade-enter-active"],
                        exit: (styles_module_default())["fade-exit"],
                        exitActive: (styles_module_default())["fade-exit-active"]
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default())["card-body"],
                        children: [
                            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Media, {
                                asset: image,
                                className: (styles_module_default()).media
                            }),
                            name && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: (styles_module_default()).name,
                                children: name
                            }),
                            position && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (styles_module_default()).position,
                                children: position
                            }),
                            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (styles_module_default()).description,
                                children: description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default())["skills-container"],
                                children: (skills || []).map(function(skill, key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (styles_module_default()).skill,
                                        children: skill
                                    }, key);
                                })
                            })
                        ]
                    })
                }, name)
            })
        ]
    });
};
/* harmony default export */ var components_TeamCard = (TeamCard);

// EXTERNAL MODULE: ./components/BlogCommon/Article/ContentfulParser/index.jsx
var ContentfulParser = __webpack_require__(92870);
// EXTERNAL MODULE: ./UI/components/AccordionItem/index.jsx
var AccordionItem = __webpack_require__(87305);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/sections/Team/utils/useSectionProps.js


/* harmony default export */ function useSectionProps(param) {
    var section = param.section, data = param.data, type = param.type;
    var ref = (0,react.useState)(0), activeAccordion = ref[0], setAccordion = ref[1];
    var ref1 = (0,react.useState)(0), activeCard = ref1[0], setCard = ref1[1];
    var ref2 = (0,helper/* getDocumentFields */.OA)(data || section, [
        "title",
        "description",
        "contentModules",
        "view", 
    ]), title = ref2.title, description = ref2.description, contentModules = ref2.contentModules, view = ref2.view;
    var handleNextClick = (0,react.useCallback)(function(length) {
        setCard(function(prevIndex) {
            return (prevIndex + 1) % length;
        });
    }, [
        setCard
    ]);
    var handlePrevClick = (0,react.useCallback)(function(length) {
        setCard(function(prevIndex) {
            return (prevIndex - 1 + length) % length;
        });
    }, [
        setCard
    ]);
    var handleAccordionClick = (0,react.useCallback)(function(id) {
        setAccordion(id);
        setCard(0);
    }, []);
    var accordionList = (0,react.useMemo)(function() {
        return (contentModules || []).map(function(item, id) {
            return (0,helper/* getDocumentFields */.OA)(item, [
                "title",
                "text", 
            ]);
        });
    }, [
        contentModules
    ]);
    var teamCardProps = (0,react.useMemo)(function() {
        var ref = (0,helper/* getDocumentFields */.OA)(contentModules[activeAccordion], [
            "contentModules"
        ]), modules = ref.contentModules;
        var ref1 = (0,helper/* getDocumentFields */.OA)(modules[activeCard], [
            "fullName",
            "avatar",
            "bio",
            "position",
            "skills", 
        ]), fullName = ref1.fullName, avatar = ref1.avatar, bio = ref1.bio, position = ref1.position, skills = ref1.skills;
        return {
            image: avatar,
            name: fullName,
            position: position,
            description: bio,
            skills: skills,
            handleNextClick: function() {
                return handleNextClick(modules === null || modules === void 0 ? void 0 : modules.length);
            },
            handlePrevClick: function() {
                return handlePrevClick(modules === null || modules === void 0 ? void 0 : modules.length);
            }
        };
    }, [
        activeAccordion,
        contentModules,
        activeCard,
        handleNextClick,
        handlePrevClick, 
    ]);
    return {
        type: type,
        view: view,
        title: title,
        description: description,
        teamCardProps: teamCardProps,
        accordionList: accordionList,
        activeAccordion: activeAccordion,
        handleAccordionClick: handleAccordionClick
    };
};

// EXTERNAL MODULE: ./UI/sections/Team/styles.module.scss
var Team_styles_module = __webpack_require__(75758);
var Team_styles_module_default = /*#__PURE__*/__webpack_require__.n(Team_styles_module);
;// CONCATENATED MODULE: ./UI/sections/Team/index.jsx









var Team = function(props) {
    var ref = useSectionProps(props), title = ref.title, description = ref.description, accordionList = ref.accordionList, activeAccordion = ref.activeAccordion, handleAccordionClick = ref.handleAccordionClick, teamCardProps = ref.teamCardProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (Team_styles_module_default()).section,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                title: title,
                description: description,
                className: (Team_styles_module_default()).sectionTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Team_styles_module_default()).contentWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (Team_styles_module_default()).accordion,
                        children: (accordionList || []).map(function(item, id) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionItem/* default */.Z, {
                                isOpen: id === activeAccordion,
                                handleClick: function() {
                                    return handleAccordionClick(id);
                                },
                                title: item.title,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                                    document: item.text,
                                    linkIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                                        type: "arrowNarrowUp"
                                    })
                                })
                            }, id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TeamCard, (0,_object_spread/* default */.Z)({}, teamCardProps))
                ]
            })
        ]
    });
};
/* harmony default export */ var sections_Team = (Team);


/***/ }),

/***/ 58754:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__q2Crw","card-header":"styles_card-header__ORjOJ","action-button":"styles_action-button__h20WP","card-body":"styles_card-body__x__lp","media":"styles_media__VSasc","name":"styles_name__hGkKE","position":"styles_position__fwFB6","description":"styles_description__zV8Vk","skills-container":"styles_skills-container__cbUlC","skill":"styles_skill__htre7","fade-enter":"styles_fade-enter__j0FmA","fade-enter-active":"styles_fade-enter-active__kBdfz","fade-exit":"styles_fade-exit__GyuxZ","fade-exit-active":"styles_fade-exit-active__sY1_A"};

/***/ }),

/***/ 34461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__iI9uz","headline-xl":"styles_headline-xl__HRBMS","headline-l":"styles_headline-l__Veh_x","headline-m":"styles_headline-m__gfh2N","headline-s":"styles_headline-s___kodX","headline-xs":"styles_headline-xs__XhN56","paragrapgh-m":"styles_paragrapgh-m__QFKni","paragrapgh-s":"styles_paragrapgh-s__4Eq1X","caption":"styles_caption__y7HHJ"};

/***/ }),

/***/ 75758:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__NMIUT","sectionTitle":"styles_sectionTitle__yz6CG","contentWrapper":"styles_contentWrapper__yzkmT","accordion":"styles_accordion___xtf3"};

/***/ })

}]);